import { computed } from 'vue'
import store from '@/store'

/**
 * Config Bus — API per i componenti (Sprint 16, epic REFACTOR-030).
 *
 * `useConfig(key)` è il canale per-chiave del bus dal punto di vista del componente:
 *   const { value: listMode, set: setListMode } = useConfig('vehicleListModeView')
 *   listMode.value        → lettura reattiva (re-render SOLO al cambio di QUESTA chiave)
 *   setListMode('table')  → scrittura ottimistica + persist batch/rollback
 *
 * Per i componenti Options-API non ancora migrati, `mapConfig([...])` espone le
 * stesse letture come computed da spreddare in `computed: { ...mapConfig([...]) }`.
 *
 * Vedi `docs/architecture/config-bus.md` §5.
 */
export function useConfig(key) {
    const value = computed(() => store.getters['config/value'](key))
    const set = (newValue) => store.dispatch('config/commitChange', { key, value: newValue })
    return { value, set }
}

/** Versione Options-API: ritorna un map { key: function } di getter computed read-only. */
export function mapConfig(keys) {
    const out = {}
    for (const key of keys) {
        out[key] = function () {
            return store.getters['config/value'](key)
        }
    }
    return out
}
